<label class="form-control-label">{{ label }}</label>
<div
  [matMenuTriggerFor]="matMenu"
  [class.control-focus]="isOpen"
  [class.disabled]="disabled"
  class="form-control"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
>
  <div class="display">{{ selected?.name || '--' }}</div>
  <capra-icon icon="icon-caret-down"></capra-icon>
</div>
<mat-menu #matMenu="matMenu" class="select-menu field-list-menu">
  <ng-container *ngIf="fieldsInEncoding.length">
    <label class="section-label">Fields used in chart</label>
    <button
      *ngFor="let item of fieldsInEncoding; trackBy: trackByName"
      [class.selected]="selected === item"
      [class.continuous]="item.value.isContinuous"
      [class.discrete]="item.value.isDiscrete"
      (click)="onChange(item)"
      class="field-menu-item"
      mat-menu-item
    >
      <capra-icon *ngIf="item.icon" [icon]="item.icon"></capra-icon>
      <span>{{ item.name }}</span>
    </button>
    <mat-divider></mat-divider>
    <label class="section-label">Other fields</label>
  </ng-container>
  <button
    *ngFor="let item of otherFields; trackBy: trackByName"
    [class.selected]="selected === item"
    [class.continuous]="item.value.isContinuous"
    [class.discrete]="item.value.isDiscrete"
    (click)="onChange(item)"
    class="field-menu-item"
    mat-menu-item
  >
    <capra-icon *ngIf="item.icon" [icon]="item.icon"></capra-icon>
    <span>{{ item.name }}</span>
  </button>
</mat-menu>
